import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface SelectPerigoI {
	value: string;
	disabled?: boolean;
	onChange: (event: SelectChangeEvent<string>) => void;
}

export default function SelectPerigo({ onChange, value, disabled }: SelectPerigoI) {

	return (
		<Select
			value={value}
			fullWidth
			onChange={onChange}
			disabled={disabled}
		>
			<MenuItem value="">Selecione</MenuItem>
			<MenuItem value="Normal">Normal</MenuItem>
			<MenuItem value="Atenção">Atenção</MenuItem>
			<MenuItem value="Alerta">Alerta</MenuItem>
			<MenuItem value="Emergência">Emergência</MenuItem>
		</Select>
	);
}